export default [
  {
    doc: 'https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=57059448',
    path: '/activity/voice_room_homepage',
    data: () => ({
      ret: 1,
      errcode: 1,
      data: {
        stage: 1,
        voices: [],
      },
      msg: '999999',
    }),
  },
  {
    doc: 'https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=57059448',
    path: '/activity/voice_room_is_apply',
    data: () => ({
      ret: 1,
      errcode: 1,
      data: {
        applied: false,
      },
      msg: '9999996666',
    }),
  },

  {
    doc: 'https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=57059448',
    path: '/activity/voice_room_apply',
    data: () => ({
      ret: 1,
      errcode: 1,
      // data: {
      //   applied: false,
      // },
      msg: '9999996666',
    }),
  },
  // {
  //   doc: 'https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=57059448',
  //   path: '/chat/sessions',
  //   data: () => ({
  //     ret: 1,
  //     errcode: 1,
  //     data: {
  //       applied: false,
  //     },
  //     msg: '9999996666',
  //   }),
  // },
]
